var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM1Icon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5617 25.8334C16.4129 25.2566 16.1123 24.7303 15.6911 24.3091C15.2699 23.8879 14.7435 23.5872 14.1667 23.4384L3.94173 20.8018C3.76728 20.7522 3.61374 20.6472 3.50442 20.5025C3.39509 20.3578 3.33594 20.1814 3.33594 20.0001C3.33594 19.8187 3.39509 19.6424 3.50442 19.4977C3.61374 19.353 3.76728 19.2479 3.94173 19.1984L14.1667 16.5601C14.7433 16.4114 15.2695 16.111 15.6907 15.6902C16.1119 15.2693 16.4127 14.7432 16.5617 14.1668L19.1984 3.94176C19.2474 3.76662 19.3524 3.61233 19.4973 3.50241C19.6422 3.3925 19.819 3.33301 20.0009 3.33301C20.1828 3.33301 20.3596 3.3925 20.5045 3.50241C20.6494 3.61233 20.7544 3.76662 20.8034 3.94176L23.4384 14.1668C23.5872 14.7435 23.8878 15.2699 24.309 15.6911C24.7302 16.1123 25.2566 16.413 25.8334 16.5618L36.0584 19.1968C36.2342 19.2453 36.3893 19.3501 36.4998 19.4952C36.6103 19.6403 36.6701 19.8177 36.6701 20.0001C36.6701 20.1825 36.6103 20.3598 36.4998 20.505C36.3893 20.6501 36.2342 20.7549 36.0584 20.8034L25.8334 23.4384C25.2566 23.5872 24.7302 23.8879 24.309 24.3091C23.8878 24.7303 23.5872 25.2566 23.4384 25.8334L20.8017 36.0584C20.7527 36.2336 20.6478 36.3879 20.5029 36.4978C20.358 36.6077 20.1811 36.6672 19.9992 36.6672C19.8174 36.6672 19.6405 36.6077 19.4956 36.4978C19.3507 36.3879 19.2457 36.2336 19.1967 36.0584L16.5617 25.8334Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 5V11.6667",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 8.33325H30",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 28.3333V31.6666",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 30H5",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM1Icon);
export default __webpack_public_path__ + "static/media/m1Icon.60d942c67e76c3d34f00a6425c05fc04.svg";
export { ForwardRef as ReactComponent };